import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_pnc.docx) y en su mismo
// orden: el modal es una vista previa, así que lo que se lee acá tiene que coincidir
// renglón por renglón con el papel. `guardable` marca los que además de imprimirse vuelven
// al cliente/trámite (ver CaratulaPncDocumentoService.persistirDatosGuardables).
//
// Son 21 renglones: PNC es la carátula de RTI recortada (sin POSIBLE 212, LIQ, CUOTA, ART,
// APORTES PROVINCIA, DDJJ SALUD, REGULARIDAD, NIVEL EDUCATIVO, PUESTO/CARGO ni los turnos
// médicos) más tres propios: CMO, CUD y AMPARO.
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    pacto: { label: 'PACTO', tipo: 'sino' },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto' },
    cidi: { label: 'CIDI', tipo: 'clave', guardable: true },

    apellidoNombre: { label: 'APELLIDO/NOMBRE', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    domicilioDni: {
        label: 'DOMICILIO DNI', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    domicilioReal: {
        label: 'DOMICILIO REAL', tipo: 'domicilio', estructurado: 'domicilioRealDatos', guardable: true,
        nota: 'Se guarda en el domicilio REAL del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto',
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Se editan desde la ficha del cliente.',
    },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },
    relacionDependencia: { label: 'RELACION DE DEPENDENCIA', tipo: 'texto' },
    autonomoMonotributo: { label: 'AUTONOMO O MONOTRIBUTO', tipo: 'texto' },
    cmo: { label: 'CMO', tipo: 'sino', guardable: true },
    cud: { label: 'CUD', tipo: 'sino', guardable: true },
    patologia: { label: 'PATOLOGÍA', tipo: 'texto', guardable: true },
    amparo: {
        label: 'AMPARO', tipo: 'sino',
        nota: 'Calculado: dice SI si el cliente ya tiene un trámite de Amparo PNC. Editarlo acá solo afecta a este documento.',
    },
    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
};

// La cabecera de PNC es la más chica de todas: una cajita con INGRESO/PACTO.
const CAJAS_CABECERA = [
    ['ingreso', 'pacto'],
];

// Bloque principal: cada entrada es una fila. Un array de 2 keys = dos columnas, igual que
// los renglones compuestos del documento.
//
// CLAVE FISCAL/CVSS y REFERENCIA/CIDI NO van acá: se dibujan aparte, arriba del recuadro,
// igual que en el papel.
const FILAS_CUERPO = [
    ['apellidoNombre'],
    ['dniCuit'],
    ['fechaNacimiento'],
    ['domicilioDni'],
    ['domicilioReal'],
    ['telefono'],
    ['mail'],
    ['estadoCivil'],
    ['relacionDependencia'],
    ['autonomoMonotributo'],
    ['cmo', 'cud'],
    ['patologia'],
    ['amparo'],
    ['observaciones'],
];

// CLAVE FISCAL/CVSS y REFERENCIA van fuera del recuadro, tal como están en el papel.
const FILAS_PREVIAS = [
    ['claveFiscal', 'claveCvss'],
    ['referencia', 'cidi'],
];

// Cómo se dibuja la hoja: título del documento, las cajitas de arriba, los renglones que
// van fuera del recuadro y el bloque principal. HojaCaratula pone el resto (modal, aviso,
// hoja A4 y botones), que es igual en las ocho carátulas.
const LAYOUT = {
    tituloDoc: 'DATOS PERSONALES',
    leyendaDoc: 'Pensión No Contributiva: PNC',
    cabecera: CAJAS_CABECERA,
    filasPrevias: FILAS_PREVIAS,
    cuerpo: FILAS_CUERPO,
};

/**
 * Modal de la Carátula PNC. Muestra los renglones prellenados (lo que ya está en el
 * cliente/trámite, o calculado desde los aportes) y en blanco lo que falta, para completar
 * antes de generar. Al confirmar, "Guardar y generar" persiste los renglones guardables y
 * emite el .docx con el DTO tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaPnc(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula PNC"
            nombreDocumento="la Carátula PNC"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
